import React from 'react';
import './GPXPointTooltip.scss';

const GPXPointTooltip = ({ pointData }) => {
  const formatDate = (timeString) => {
    if (!timeString) return 'N/A';
    try {
      const date = new Date(timeString);
      const day = date.getDate();
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit' });
      return `${day} ${month} ${year}, ${time}`;
    } catch (e) {
      return timeString;
    }
  };

  const formatElevation = (elevation) => {
    if (elevation === undefined || elevation === null) return 'N/A';
    return `${elevation.toFixed(1)} m`;
  };

  return (
    <div className="gpx-point-tooltip">
      <div className="tooltip-header">
        <h4>GPX Track Point #{pointData.index + 1}</h4>
      </div>
      <div className="tooltip-content">
        <div className="info-row">
          <span className="label">Coordinates:</span>
          <span className="value">
            {pointData.lat.toFixed(6)}, {pointData.lng.toFixed(6)}
          </span>
        </div>
        {pointData.elevation !== undefined && (
          <div className="info-row">
            <span className="label">Elevation:</span>
            <span className="value">{formatElevation(pointData.elevation)}</span>
          </div>
        )}
        {pointData.time && (
          <div className="info-row">
            <span className="label">Time:</span>
            <span className="value">{formatDate(pointData.time)}</span>
          </div>
        )}
        {Object.keys(pointData).some(
          (key) => !['lat', 'lng', 'elevation', 'time', 'index'].includes(key) && pointData[key],
        ) && (
          <div className="additional-data">
            <div className="label">Additional Data:</div>
            {Object.entries(pointData)
              .filter(([key]) => !['lat', 'lng', 'elevation', 'time', 'index'].includes(key))
              .map(([key, value]) => (
                <div key={key} className="info-row">
                  <span className="label">{key}:</span>
                  <span className="value">{String(value)}</span>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GPXPointTooltip;
